import Axios from "axios"
import { sortCaret } from "../../../_metronic/_helpers";
import React from "react";
import { Badge } from "react-bootstrap";
/* const url_categories_dev =; */
import axiosCancel from 'axios-cancel';

axiosCancel(Axios);
const url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/groups";

function ActionsColumnFormatter(cellContent, row, rowIndex) {
  const types = {
    Male: "warning",
    Female: "primary",
  };
  return (
    <h5>
      {row.genders.map((input) => (
        <Badge variant={types[input] || "danger"} className="p-2 mx-1">
          {input || "null"}
        </Badge>
      ))}
    </h5>
  );
}

export const columns = [
  {
    dataField: "name",
    text: "Group Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "salary",
    text: "salary per hour",
    sort: true,
sortCaret: sortCaret,
    formatter: (cellContent, row, rowIndex) => <>${row.salary}</>,
  },
  {
    dataField: "ages_range",
    text: "Ages Range",
    sort: true,
sortCaret: sortCaret,
    formatter: (cellContent, row, rowIndex) => (
      <Badge variant="success">
        {row.ages_range[0]} - {row.ages_range[1]}
      </Badge>
    ),
  },
  {
    dataField: "weights_range",
    text: "Weight Range",
    sort: true,
sortCaret: sortCaret,
    formatter: (cellContent, row, rowIndex) => (
      <Badge variant="dark">
        {row?.weights_range?.[0]}lbs - {row?.weights_range?.[1]}lbs
      </Badge>
    ),
  },
  {
    dataField: "heights_range",
    text: "Height Range",
    sort: true,
sortCaret: sortCaret,
    formatter: (cellContent, row, rowIndex) => (
      <Badge variant="info">
        {row.heights_range[0]}M - {row.heights_range[1]}M
      </Badge>
    ),
  },
  {
    dataField: "genders",
    text: "Genders",
    sort: true,
sortCaret: sortCaret,
    formatter: ActionsColumnFormatter,
  },
];

export function getClients(setCategory) {
  Axios.get(`${url}/find`)
    .then((res) => {
      const categories = res.data.payload;
      console.log(categories);
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.log('another error happened')
      }
  })}
export function getClient(uid) {
  return Axios.get(`${url}/find/${uid}`);
}
export function updateClient(tasks) {
  if (tasks.uid) {
    return Axios.put(`${url}/update/${tasks.uid}`, tasks);
  } else {
    return Axios.post(`${url}/create`, tasks);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url}/delete/${uid}`);
}
export function getUsersByGroup(group_id) {
  return Axios.get(`${url}/filter/${group_id}`)
}
export function filterByGroup(group, users) {
  function _calculateAge(born) {
    const ageDifMs = Date.now() - born.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }
  try {


    console.log(group)
    
    const [h_min, h_max] = group.heights_range
    const [a_min, a_max] = group.ages_range;
    const by_height = users.filter(
      (user) => h_max > user.height && user.height > h_min
    );
    const by_age = by_height.filter((user) => {
      const age = _calculateAge(new Date(user.born));
      return a_max > age && age > a_min;
    });

    const by_gender = by_age.filter((user) => {
      const g_formatted = group.genders.map((gender) => gender[0]);
      return g_formatted.includes(user.genre)
    });
    return by_gender
  } catch (e) {
    console.warn(e)
  }

}